import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type TrackAskAQuestionClickedPayload = TrackingPayload;

const trackAskAQuestionClickedAnalytics = (payload: TrackAskAQuestionClickedPayload) => {
    track(TrackingEvents.Auctioneer.AskAQuestionPressed, payload);
};

export const useTrackAskAQuestionClickedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        () =>
            trackAskAQuestionClickedAnalytics({
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            }),
        [pathname, url]
    );
};
